import { useState } from 'react';
import type { Api, UserInfo } from '../api';
import { EmailCheckField } from './EmailCheckField';
import { useEmailCheck } from './useEmailCheck';

/**
 * 새 이메일 지정(관리자, §14.19.10) — 조직을 되살렸는데 원래 주소를 그사이 다른 계정이 써서 되찾지 못한 사용자에게만.
 * 다른 이메일 입력 화면과 같은 규칙: 형식 검사 + [중복 확인] 을 통과해야 [지정] 이 켜진다(최종 판정은 서버 409).
 * 사용자 행마다 훅이 필요해 별도 컴포넌트로 둔다(목록 안에서 조건부로 훅을 부를 수 없다).
 *
 * @param onSubmit 지정 실행(부모의 행 잠금·알림·재조회 흐름을 그대로 쓰도록 부모가 넘긴다)
 * @param onCancel 패널 닫기
 */
export function EmailAssignPanel({
  api,
  user,
  onSubmit,
  onCancel,
  busy,
}: {
  api: Api;
  user: UserInfo;
  onSubmit: (email: string) => void;
  onCancel: () => void;
  busy: boolean;
}) {
  const [value, setValue] = useState('');
  const emailCheck = useEmailCheck(api, value);
  return (
    <div>
      <div className="hint" style={{ marginBottom: 8 }}>
        원래 주소 <b>{user.originalEmail}</b> 은(는) 조직이 삭제된 동안 다른 계정이 쓰게 되어 되찾지 못했습니다.
        새 이메일을 지정한 뒤 [다시 활성화] 하면 그 주소로 로그인합니다(비밀번호는 그대로).
      </div>
      <div className="row" style={{ flexWrap: 'wrap', alignItems: 'flex-start' }}>
        <EmailCheckField
          value={value}
          onChange={setValue}
          emailCheck={emailCheck}
          placeholder="new@example.com"
          autoFocus
          ariaLabel="새 이메일"
        />
        <button onClick={() => onSubmit(value.trim())} disabled={busy || !emailCheck.view.confirmed}>
          {busy ? '지정 중…' : '지정'}
        </button>
        <button className="ghost" onClick={onCancel}>
          취소
        </button>
      </div>
    </div>
  );
}
